/**
 * Converts a photo value (filename or legacy full URL) to a displayable URL.
 * - Legacy data (starts with http): used as-is
 * - Legacy data (starts with /uploads/): prepend BACKEND_URL
 * - New data (filename only): build full URL with BACKEND_URL/uploads/
 */
export const getPhotoUrl = (photo) => {
    if (!photo) return '';
    if (photo.startsWith('http')) return photo;
    const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
    if (photo.startsWith('/')) return `${backendUrl}${photo}`;
    return `${backendUrl}/uploads/${photo}`;
};
